import React, { Component } from "react";
import request from "orcrist-request";
// import { Toast } from 'antd-mobile';
import * as Utils from "../../utils/utils";
import reqHostName from "../../utils/env";
import OstMask from "../../../OstMask";
import Loading from "../../../Loading";
import * as styles from "./style.less";

export default class UserAgreement extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      data: "",
      isLoading: false,
    };
  }

  fetchData = (sources: string) => {
    let options = {
      method: "get",
    };
    request(
      `/api/trading-product/config/project/${sources}/projectRegistrationProtocol`,
      options
    ).then((resData: any) => {
      if (resData && resData.code === "0" && resData.data) {
        this.setState({
          data: resData.data,
        });
      } else {
        // Toast.info('网络异常，稍后再试', 3);
      }
    });
  };

  fetchCDNData = (sources: any) => {
    let options = {
      method: "get",
    };
    request(
      `${reqHostName()}/project/projectRegistrationProtocol/${sources}.json`,
      options
    ).then((resData: any) => {
      if (resData && resData.projectRegistrationProtocol) {
        this.setState({
          data: resData.projectRegistrationProtocol,
        });
      } else {
        this.fetchData(sources);
      }
    });
  };

  componentDidMount() {
    let sources = Utils.getSources();
    if (
      window.location.hostname === "0.0.0.0" ||
      window.location.hostname === "spcare.medbanks-test.com"
    ) {
      sources = sources === "1100110101" ? "1000000000" : sources;
    }
    if (sources && !this.state.data) {
      this.fetchCDNData(sources);
    }
  }

  render() {
    const { isOpenAgreement, closeAgreementHandle } = this.props;
    let html = { __html: this.state.data };
    return (
      <OstMask show={isOpenAgreement}>
        <div className={styles.userAgreement}>
          <header className={styles.userAgreementHeader}>
            <div className={styles.title}>平台用户协议</div>
            <div className={styles.close} onClick={closeAgreementHandle}></div>
          </header>
          <section
            className={styles.agreementContent}
            dangerouslySetInnerHTML={html}
          ></section>
          <Loading isLoading={this.state.isLoading} />
        </div>
      </OstMask>
    );
  }
}
